import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import NumberFormat from "react-number-format";
import TextEditor from "./../../component/common/TextEditor";
import CONSTANT from "./../../constant";

import {
  onChange,
  setOptions,
  validateForm,
  getStorage,
  setRequired,
  getCookie,
  onArrayChange,
  setValue,
} from "./../../utils";
import { getAvailableNotings } from "./../../actions/MasterAction";
import { getApprovingAuthority } from "../../actions/UserAction";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const recipients = getStorage(CONSTANT.cookie.recipients);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    const detail = props.detail;
    const approver = props.approver;
    const hasAccessToApproveNoting =
      props.approver.filter((i: any) => i.code === userDetail.code).length > 0;

    // Try to load draft data from localStorage
    const draftData = this.loadDraftData(detail.code);

    this.state = {
      fileCode: detail.code,
      hasAccessToApproveNoting,
      financialImplication: {
        name: "financialImplication",
        value:
          draftData?.financialImplication ||
          (detail ? detail.financialImplication : ""),
        error: "",
        isRequired: true,
      },
      approvingAuthority: {
        name: "approvingAuthority",
        value:
          draftData?.approvingAuthority ||
          (approver.length > 0 ? approver[0].code : ""),
        error: "",
        isRequired: true,
        options: [],
      },

      notings: {
        name: "notings",
        value: draftData?.notings || [],
        options: [],
        error: "",
        isRequired: true,
      },
      fileStatus: {
        name: "fileStatus",
        value: draftData?.fileStatus || false,
        options: CONSTANT.static.fileStatus,
        error: "",
        isRequired: true,
      },
      comment: {
        name: "comment",
        value: draftData?.comment || "",
        error: "",
        isRequired: false,
      },
      to: {
        name: "to",
        value: draftData?.to || [],
        options: recipients,
        error: "",
        isRequired: !this.props.pendingWith.some(
          (item: any) => item.isReviewed
        ),
      },
      attachments: {
        name: "attachments",
        value: draftData?.attachments || [],
        error: "",
        isRequired: false,
      },

      showLoader: false,
      isApprovingAuthority: false,
    };
  }

  // Load draft data from localStorage
  loadDraftData = (fileCode: string) => {
    const draftKey = `draft_${fileCode}`;
    const draftData = localStorage.getItem(draftKey);
    return draftData ? JSON.parse(draftData) : null;
  };

  // Save draft data to localStorage
  saveDraft = () => {
    const {
      fileCode,
      financialImplication,
      approvingAuthority,
      notings,
      fileStatus,
      comment,
      to,
      attachments,
    } = this.state;

    const draftData = {
      financialImplication: financialImplication.value,
      approvingAuthority: approvingAuthority.value,
      notings: notings.value,
      fileStatus: fileStatus.value,
      comment: comment.value,
      to: to.value,
      attachments: attachments.value,
    };

    this.props.toggleModal();

    const draftKey = `draft_${fileCode}`;
    localStorage.setItem(draftKey, JSON.stringify(draftData));
  };

  // Clear draft data from localStorage
  clearDraft = () => {
    const { fileCode } = this.state;
    const draftKey = `draft_${fileCode}`;
    localStorage.removeItem(draftKey);
  };

  validateFiles = (event: any) => {
    const validExtensions = [
      ".doc",
      ".docx", // Word Documents
      ".xls",
      ".xlsx",
      ".xml", // Excel Files
      ".ppt",
      ".pptx", // PowerPoint Files
      ".pdf",
      ".jpeg",
      ".jpg",
    ];

    const files = Array.from(event.target.files); // Convert FileList to Array

    // Filter valid files
    const validFiles = files.filter((file: any) => {
      const fileExtension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      return validExtensions.includes(fileExtension);
    });

    // Check if the number of valid files matches the total number of files
    if (validFiles.length === files.length) {
      return true; // All files are valid
    } else {
      alert(
        "Some files are invalid. Please upload only MS Office files (doc, docx, xls, xlsx, ppt, pptx, xml, pdf, jpeg, jpg)."
      );
      return false; // There are invalid files
    }
  };

  dltItem = (index: any, array: any) => {
    array.splice(index, 1);
    setValue(this, this.state.attachments.name, array);
  };

  componentDidMount() {
    document.title = CONSTANT.pageTitle.login;
    const { hasAccessToApproveNoting } = this.state;
    getApprovingAuthority().then((res: any) => {
      setOptions(this, this.state.approvingAuthority.name, res.result);
    });

    getAvailableNotings().then((res: any) => {
      if (!hasAccessToApproveNoting) {
        const notings = res.result.filter((i: any) => i.code !== 1);
        const newLists = notings.filter((item: any, index: any) => {
          return item.name !== "अनुमोदित  / Approved"
            ? item
            : hasAccessToApproveNoting
            ? item
            : "";
        });

        setOptions(this, this.state.notings.name, newLists);
      } else {
        setOptions(this, this.state.notings.name, res.result);
      }
    });
  }

  checkIfAtleatOneReviewed() {
    return this.props.pendingWith.find((item: any) => item.isReviewed);
  }

  render() {
    const dltFile = this;
    const {
      notings,
      comment,
      to,
      attachments,
      fileStatus,
      financialImplication,
      approvingAuthority,
      showLoader,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <form className="" onSubmit={this.onSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group mb-0">
                    <label>
                      Financial implication{" "}
                      <small className="text-danger">*</small>
                    </label>
                    <NumberFormat
                      decimalScale={2}
                      thousandSeparator={true}
                      allowNegative={false}
                      className={
                        financialImplication.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder="Must be greater than or equal to zero"
                      name={financialImplication.name}
                      value={financialImplication.value}
                      onValueChange={(e: any) => {
                        this.onChange({
                          target: {
                            name: financialImplication.name,
                            value: e.value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-0">
                    <label>
                      Approving authority{" "}
                      <small className="text-danger">*</small>
                    </label>
                    {/* <select
                                            className={approvingAuthority.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={approvingAuthority.name}
                                            value={approvingAuthority.value}
                                            onChange={this.onChange}
                                        >
                                            <option value="">Select a Approver</option>
                                            {
                                                approvingAuthority.options.map(function (item: any, index: number) {
                                                    return (
                                                        <option key={index} value={item.code}>{item.name} - {item.employeeNumber}</option>
                                                    )
                                                })
                                            }
                                        </select> */}
                    <Typeahead
                      id="ta-approver"
                      labelKey={(option: any) =>
                        `${option.name} (${option.employeeNumber})`
                      }
                      options={approvingAuthority.options}
                      selected={
                        approvingAuthority.value
                          ? approvingAuthority.options.filter(
                              (o: any) => o.code === approvingAuthority.value
                            )
                          : []
                      }
                      onChange={(selected: any[]) => {
                        this.onChange({
                          target: {
                            name: approvingAuthority.name,
                            value: selected.length ? selected[0].code : "",
                          },
                        });
                      }}
                      placeholder="Select an Approver"
                      isInvalid={approvingAuthority.error.length > 0}
                      multiple={false}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-0">
                    <label>
                      File status <small className="text-danger">*</small>
                    </label>
                    <select
                      className={
                        fileStatus.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name={fileStatus.name}
                      value={fileStatus.value}
                      onChange={this.onChange}
                    >
                      {fileStatus.options.map(function (
                        item: any,
                        index: number
                      ) {
                        return (
                          <option key={index} value={item.code}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {!fileStatus.value && (
                  <div className="col-md-6">
                    <div className="form-group mb-0">
                      <label>
                        Recipient <small className="text-danger">*</small>
                      </label>
                      <Typeahead
                        disabled={this.checkIfAtleatOneReviewed()}
                        id="ta-recipient"
                        labelKey={(option: any) =>
                          `${option.name} (${option.employeeNumber})`
                        }
                        name={to.name}
                        defaultSelected={
                          this.checkIfAtleatOneReviewed() &&
                          this.props.nextlevelReviewers
                        }
                        value={to.value}
                        multiple={false}
                        options={to.options}
                        onChange={(e: any) =>
                          this.typeaheadOnChange(to.name, e)
                        }
                        placeholder="Send this file to"
                        isInvalid={to.error.length > 0}
                      />
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  <div className="form-group mb-0">
                    <label>
                      Notings <small className="text-danger">*</small>
                    </label>
                    <select
                      className={
                        notings.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name={notings.name}
                      value={notings.value}
                      onChange={this.onChange}
                    >
                      <option>Select a Noting</option>
                      {notings.options.map(function (item: any, index: number) {
                        return (
                          <option key={index} value={item.code}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group mb-0">
                    <label>
                      Message <sup>(optional)</sup>
                    </label>
                    <TextEditor
                      error={comment.error}
                      name={comment.name}
                      value={comment.value}
                      onChange={this.onChange}
                      placeholder="Enter your message here"
                      class="mb-3"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group mb-0">
                    <label>
                      File(s) <sup>(optional)</sup>
                    </label>
                    <input
                      name={attachments.name}
                      onChange={(e: any) => {
                        if (this.validateFiles(e)) {
                          this.onChange(e);
                          e.target.value = null;
                        }
                      }}
                      type="file"
                      multiple={true}
                      className="form-control"
                      style={{ padding: 4 }}
                    />
                  </div>
                  <div className="mb-3">
                    {Array.from(attachments.value).map(function (
                      item: any,
                      index: number,
                      array: any
                    ) {
                      return (
                        <span key={index} className="badge badge-primary mr-1">
                          {item.name}
                          <i
                            onClick={(e) => dltFile.dltItem(index, array)}
                            className="fa fa-times "
                            style={{ color: "red" }}
                            aria-hidden="true"
                          />
                        </span>
                      );
                    })}
                  </div>
                </div>

                {/* Action buttons */}
                <div className="col-md-3">
                  <button
                    type="button"
                    onClick={this.props.toggleModal}
                    className="btn btn-block cancel-button btn-sm"
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-md-3">
                  <button
                    type="button"
                    onClick={this.saveDraft}
                    className="btn btn-block btn-secondary btn-sm"
                  >
                    Save as Draft
                  </button>
                </div>
                <div className="col-md-3">
                  <button
                    type="submit"
                    className="btn btn-block submit-button btn-sm"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  onChange = (e: any) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === this.state.attachments.name) {
      let selectedFiles = Array.from(e.target.files);
      if (this.state.attachments.value.length > 0) {
        value = [...this.state.attachments.value, ...selectedFiles];
      } else {
        value = selectedFiles;
      }
    }

    if (name === this.state.fileStatus.name) {
      value = value === "true";
      const confirmResponse = window.confirm(
        "Are you sure, you want to update the file status?"
      );
      if (confirmResponse) {
        setRequired(this, this.state.to.name, !value, () => {
          onChange(this, this.state.to.name, []);
        });
      } else {
        return;
      }
    }

    onChange(this, name, value);
  };

  typeaheadOnChange = (name: string, e: any) => {
    let value = e;
    if (e.length > 0 && e[0].customOption) {
      value = [{ name: e[0].name }];
    }
    if (name === "to") {
      onArrayChange(this, name, value);
    } else {
      onChange(this, name, value);
    }
  };

  onSubmit = (e: any) => {
    let { to } = this.state;
    e.preventDefault();

    if (validateForm(this)) {
      if (
        to.value.length &&
        to.value.length > 0 &&
        this.state.fileStatus.value == false
      ) {
        const st = this.state;
        const model = {
          fileCode: st.fileCode,
          fileStatus: st.fileStatus.value,
          notings: st.notings.value,
          comment: st.comment.value,
          to: this.checkIfAtleatOneReviewed() ? [] : st.to.value,
          financialImplication: st.financialImplication.value,
          approvingAuthority: [st.approvingAuthority.value],
        };
        this.props.onSubmit(model, st.attachments.value);
      } else if (this.state.fileStatus.value == true) {
        const st = this.state;
        const model = {
          fileCode: st.fileCode,
          fileStatus: st.fileStatus.value,
          notings: st.notings.value,
          comment: st.comment.value,
          to: this.checkIfAtleatOneReviewed() ? [] : st.to.value,
          financialImplication: st.financialImplication.value,
          approvingAuthority: [st.approvingAuthority.value],
        };
        this.props.onSubmit(model, st.attachments.value);
      }

      // Clear draft after successful submission
      this.clearDraft();
    }
  };
}

export default ComponentName;
